import type { ResultOf } from '@graphql-typed-document-node/core'
import type { InventoryCalendarItem } from '~/components/fusuma/sd/visitCondition'
import type { PlanSelectionInfo } from '~/components/plan/PlanSelectionInfo.frag'
import { useInitialTimesPosition } from '~/hooks/useInitialTimesPosition'
import type { HourMinute } from '~/lib/graphql/scalars'
import { money } from '~/lib/money/money'

type Props = {
  inventory: ResultOf<typeof InventoryCalendarItem>['inventory'][number]
  mealPeriod: ResultOf<typeof PlanSelectionInfo>['mealPeriod']
  onClickTime: (visitTime: HourMinute) => void
  slideIndex: number
  isSeatOnly: boolean
}

const InventoryTime: React.FC<Props> = ({
  inventory,
  mealPeriod,
  onClickTime,
  slideIndex,
  isSeatOnly,
}) => {
  useInitialTimesPosition({
    type: 'planConfirmed',
    mealPeriod,
    slideIndex,
    visitTime: inventory.visitTime,
  })
  return (
    <div>
      <button
        type="button"
        onClick={() => onClickTime(inventory.visitTime)}
        className="h-12 w-full rounded-md bg-accent-brown p-1 text-neutral-100"
      >
        <span className="block text-sm font-bold">{inventory.visitTime}</span>
        {!isSeatOnly && <span className="block">{money(inventory.price)}円</span>}
      </button>
    </div>
  )
}

export default InventoryTime
